import { action, set } from '@ember/object';
import PaperForm from 'ember-paper/components/paper-form';

class PaperFormWithErrors extends PaperForm {
  get validationErrorMessages() {
    return this.childComponents.reduce((errors, field) => {
      if (!field.isInvalid) {
        // We don't need to include valid fields.
        return errors;
      }

      // Autocomplete fields show up twice (element + trigger input).
      // Include the autocomplete itself, but skip its trigger input.
      if (
        field.element === null ||
        !field.element.classList.contains(
          'ember-paper-autocomplete-search-input',
        )
      ) {
        errors.push({
          field,
          errors: field.validationErrorMessages,
        });
      }

      return errors;
    }, []);
  }

  @action
  localOnSubmit() {
    if (this.isInvalid) {
      this.childComponents.forEach((child) => set(child, 'isTouched', true));
      this.childComponents = [...this.childComponents];
      this.onInvalid?.();
    } else {
      this.onSubmit?.();
      // Don't flag child components as untouched, in case the save fails.
    }
  }
}

export default PaperFormWithErrors;
